import { Content } from '../../../models/content/types';
import FeedHeader, { FeedHeaderProps, FeedViewAllFooter } from './feed-header';

import './content-layouts.scss';
import {
  FeedCardWithData,
  MobileScrollCard,
} from '../../content/solar-feed-card/solar-feed-card';
import { FeedCardHorizontalScroller } from '@socialchorus/shared-ui-components';
import useScreenSize from '../../../common/use-screen-size';
import { MobileHorizontalFeedCards } from './horizontal-scroll-row';

type ContentLayoutRow = FeedHeaderProps & {
  contents: Content[];
  description?: string;
  feedUrl: string;
  viewAllText: string;
  isFetching: boolean;
  minLength: number;
  isTopic: boolean;
  /** The caller decides whether mobile-web treatment applies here — it also
   * owns the container markup those layouts depend on, which this component
   * has no visibility into. */
  mobileWebLayouts: boolean;
  mobileWebParity: boolean;
};

const ContentLayoutRow = ({
  id,
  title,
  description,
  viewAllText,
  viewAllContext,
  feedUrl,
  isFetching,
  minLength,
  contents,
  analyticsData,
  isTopic = false,
  mobileWebLayouts,
  mobileWebParity,
}: ContentLayoutRow) => {
  const { isMobile } = useScreenSize();
  const isMobileModule = isMobile && !!(mobileWebLayouts || mobileWebParity);

  const MAX_ITEMS = 3;
  const displayedContents = contents.slice(0, MAX_ITEMS);

  if (!isFetching && displayedContents.length < minLength) return null;

  // Note: Placeholder not implimented when fetching

  return (
    <>
      <FeedHeader
        id={id}
        title={title}
        description={description}
        viewAllLink={feedUrl}
        viewAllText={viewAllText}
        viewAllContext={viewAllContext}
        isTopic={isTopic}
        analyticsData={analyticsData}
        isMobileModule={isMobileModule}
      />
      {isMobile && mobileWebLayouts ? (
        <div className="content-layout__mobile-scroller">
          <FeedCardHorizontalScroller
            itemWidth="minimal"
            items={contents.map((content) => (
              <MobileScrollCard
                key={content.id}
                content={content}
                analyticsData={analyticsData}
                titleHeadingLevel={2}
              />
            ))}
          />
        </div>
      ) : isMobile && mobileWebParity ? (
        <MobileHorizontalFeedCards
          contents={contents}
          analyticsData={analyticsData}
          title={title}
        />
      ) : (
        <div className={'content-layout__row'}>
          {displayedContents.map((content) => (
            <div className={'content-layout__row-card'} key={content.id}>
              <FeedCardWithData
                content={content}
                analyticsData={analyticsData}
                compact
                fullHeight
                layout="vertical"
                titleHeadingLevel={2}
              />
            </div>
          ))}
        </div>
      )}
      {isMobileModule && feedUrl && (
        <FeedViewAllFooter
          viewAllLink={feedUrl}
          viewAllText={viewAllText}
          viewAllContext={viewAllContext}
          isTopic={isTopic}
          analyticsData={analyticsData}
        />
      )}
    </>
  );
};

export default ContentLayoutRow;
